import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

let basesPromise = null;

/** Military installations (cached for the session). */
export function useBases() {
  const [bases, setBases] = useState([]);
  useEffect(() => {
    basesPromise = basesPromise || api.get("/bases", { params: { radius: 10 } }).then((r) => r.data);
    basesPromise.then(setBases).catch(() => {
      basesPromise = null;
    });
  }, []);
  return bases;
}

/** Feed status + site settings (REIN source, Matrix search link). */
export function useMeta() {
  const [meta, setMeta] = useState(null);
  const load = useCallback(() => api.get("/meta").then((r) => setMeta(r.data)).catch(() => setMeta(null)), []);
  useEffect(() => {
    load();
  }, [load]);
  return { meta, reload: load };
}

/** Listing search against the API. `params` must be a stable object (memoize it). */
export function useListings(params) {
  const [state, setState] = useState({ loading: true, data: null, error: null });
  const key = JSON.stringify(params || {});
  useEffect(() => {
    let alive = true;
    setState((s) => ({ ...s, loading: true }));
    api
      .get("/listings", { params: JSON.parse(key) })
      .then((r) => alive && setState({ loading: false, data: r.data, error: null }))
      .catch((e) => alive && setState({ loading: false, data: null, error: e }));
    return () => {
      alive = false;
    };
  }, [key]);
  return state;
}
